import { useEffect, useState } from 'react'

// setTimeout overflows above 2^31 - 1 ms (~24.8 days); re-check at least that often.
const MAX_TIMEOUT_MS = 2 ** 31 - 1

/** The earliest of `instants` after `now`, or null if none are ahead. */
export const nextInstant = (instants: number[], now: number) => {
  const upcoming = instants.filter((t) => Number.isFinite(t) && t > now)
  return upcoming.length ? Math.min(...upcoming) : null
}

/** Re-renders once when `at` (epoch ms) passes. One timer per call, however many boundaries feed it. */
export const useRerenderAt = (at: number | null) => {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (at === null) return
    // +1ms so the timer lands just past the boundary, not on it.
    const delay = Math.min(Math.max(at - Date.now() + 1, 0), MAX_TIMEOUT_MS)
    const id = setTimeout(() => setTick((t) => t + 1), delay)
    return () => clearTimeout(id)
  }, [at, tick])
}
